export default "__VITE_ASSET__326e4c65__"